import React, {
  useContext,
  useRef,
  useState,
} from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { CountryDropdown } from 'react-country-region-selector';
import { appStore } from '../../state/app';
import CustomBtn from '../../generic/CustomBtn';
import CustomInput from '../../generic/CustomInput';
import storage from '../../utils/storage';
import registerUser from '../../services/registerUser';
import CustomPopup from '../../generic/CustomPopup';
import {
  DuplicateAccountIdOrEmailProjectOperator,
  UserHasNotVerified,
  ValidateError,
} from '../../constans/constans';
import loginUser from '../../services/loginUser';
import { isValidHttpUrl } from '../../utils/helpers';
import { buildLoginPayload, isWalletCancelError } from '../../utils/near-utils';

const CreateAcc = () => {
  const myRef = useRef(null);
  const refSite = useRef(null);
  const history = useHistory();
  const translate = useIntl();
  const { state, update } = useContext(appStore);
  const { wallet, account } = state;
  const { register, handleSubmit, errors, watch } = useForm();
  const [countries, setCountries] = useState({ country: '', select: false });
  const [countriesArray, setCountriesArray] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [textError, setTextError] = useState({ text: '', type: '' });
  const [errorWebsite, setErrorWebsite] = useState(false);

  const valuesCheckBox = [
    { id: 'acc.type-afforestation-reforestation', value: 'Afforestation / Reforestation' },
    { id: 'acc.type-forest-conservation', value: 'Forest Conservation' },
    { id: 'acc.type-improved-forest-management', value: 'Improved Forest Management' },
    { id: 'acc.type-assisted-natural-regeneration', value: 'Assisted Natural Regeneration' },
    { id: 'acc.type-agroforestry', value: 'Agroforestry' },
  ];

  const handleError = (code) => {
    console.log('code', code);
    switch (code.status) {
      case DuplicateAccountIdOrEmailProjectOperator:
        setTextError({
          text: translate.formatMessage({ id: 'acc.error-auth' }),
          type: translate.formatMessage({ id: 'acc.input-email' }),
        });
        setErrorModal(true);
        return false;
      case UserHasNotVerified:
        setTextError({
          text: translate.formatMessage({ id: 'acc.error-wallet' }),
          type: translate.formatMessage({ id: 'acc.input-email' }),
        });
        setErrorModal(true);
        return true;
      case ValidateError:
        setTextError({
          text: translate.formatMessage({ id: 'acc.error-filled' }),
          type: translate.formatMessage({ id: 'acc.input-valid' }),
        });
        setErrorModal(true);
        return true;
      default:
        return false;
    }
  };

  const checkAuth = async (currentAccount) => {
    const loginPayload = await buildLoginPayload(currentAccount);
    if (!loginPayload) return false;
    const res = await loginUser(loginPayload).catch((e) => {
      if (e.response.data) {
        return handleError(e.response.data);
      }
    });
    return res;
  };

  const onSubmit = async (data) => {
    update('loading', true);
    let currentAccount = account;
    try {
      const connected = await wallet.signIn({ forceConnect: true });
      if (!connected) {
        update('loading', false);
        return;
      }
      currentAccount = await wallet.account();
    } catch (e) {
      update('loading', false);
      if (isWalletCancelError(e)) return;
      return;
    }
    const accountId = currentAccount?.accountId;
    if (!accountId) {
      update('loading', false);
      return;
    }
    const {
      organisationName,
      contactPerson,
      email,
      website,
      checkbox,
      howLong,
      shortDescription,
      descriptionOfOrganisation,
    } = data;

    const dataForReq = {
      account_id: accountId,
      organization: {
        contact_person: contactPerson,
        description: descriptionOfOrganisation || '',
        email: email || '',
        name: organisationName,
        short_description: shortDescription || '',
        days_in_project: +howLong || 0,
        types: checkbox || [],
        countries: countriesArray || [],
        website: website || '',
      },
      user_name: accountId,
    };
    if (website && !isValidHttpUrl(website)) {
      refSite.current.scrollIntoView();
      return setErrorWebsite(!isValidHttpUrl(website));
    }
    setErrorWebsite(false);
    try {
      await registerUser(dataForReq);
    } catch (error) {
      console.log('error', error.response);
      if (error.response) {
        if (error.response?.data?.status === DuplicateAccountIdOrEmailProjectOperator) {
          update('loading', false);
          return handleError(error.response.data);
        }
        const valueReg = await checkAuth(currentAccount);
        if (valueReg) {
          update('loading', false);
          return handleError(error.response.data);
        }
        update('loading', false);
        myRef.current.scrollIntoView();
        return setEmailError(true);
      }
      return true;
    }
    update('loading', false);
    storage.set('emailUser', email);
    return history.push('/ready-page');
  };

  const updateCountries = (value) => {
    setCountries({ country: value, select: true });
    if (!(countriesArray.includes(value)) && value) setCountriesArray([...countriesArray, value]);
  };

  const deleteCountry = (value) => {
    const currentArray = countriesArray.filter((el) => el !== value);

    setCountriesArray(currentArray);
    if (currentArray.length === 0) {
      setCountries({ country: '' });
    }
    setCountries({ country: '' });
  };

  const websiteValue = watch('website');
  const hasInvalidWebsite = !!websiteValue && errorWebsite;
  const errorCountries = (!(countriesArray.length > 0) && countries.select);
  const hasValidationErrors = Object.keys(errors).length > 0 || errorCountries || hasInvalidWebsite || emailError;
  const classBtn = hasValidationErrors ? 'btn__login-signIn marginTop' : 'btn__login-signIn active marginTop';

  return (
    <section className="registration__form">
      <>
        <FormattedMessage
          id="acc.title"
          values={{
            h2: (...chunks) => <h2 className="registration__form-title">{chunks}</h2>,
          }}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={`registration__form-inputWrapper ${errors.organisationName && 'registration__form-spaceForError'}`}>
            <CustomInput
              type="text"
              name="organisationName"
              label={translate.formatMessage({ id: 'acc.input-company' })}
              placeholder={translate.formatMessage({ id: 'acc.input-company' })}
              customClassLabel="input__label-registration bold"
              customClass="input__registration"
              error={errors.organisationName}
              register={register({
                required: true, maxLength: 180,
              })}
            />
          </div>
          <div className={`registration__form-inputWrapper ${errors.contactPerson && 'registration__form-spaceForError'}`}>
            <CustomInput
              type="text"
              name="contactPerson"
              label={translate.formatMessage({ id: 'acc.input-contactPerson' })}
              placeholder={translate.formatMessage({ id: 'acc.input-contactPerson' })}
              customClassLabel="input__label-registration bold"
              customClass="input__registration"
              error={errors.contactPerson}
              register={register({
                required: true, maxLength: 180,
              })}
            />
          </div>
          <div className={`registration__form-inputWrapper ${(errors.email || emailError) && 'registration__form-spaceForError'}`} ref={myRef}>
            <CustomInput
              type="text"
              name="email"
              change={() => setEmailError(false)}
              label={translate.formatMessage({ id: 'acc.input-email'})}
              placeholder={translate.formatMessage({ id: 'acc.input-email'})}
              customClassLabel="input__label-registration bold"
              customClass="input__registration"
              error={errors.email}
              register={register({
                required: true,
                maxLength: 180,
                // eslint-disable-next-line no-useless-escape
                pattern: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
              })}
            />
            {(!errors.email && emailError) && <div className="input__customEmailError">{translate.formatMessage({ id: 'acc.email-error' })}</div>}
          </div>
          <div className={`registration__form-inputWrapper ${errors.descriptionOfOrganisation && 'registration__form-spaceForError'}`}>
            <div className="textareaBlock">
              <h4 className="textareaBlock-Label">
                {translate.formatMessage({ id: 'acc.input-description' })}
              </h4>
              <textarea
                className={`textareaBlock-Textarea ${errors.descriptionOfOrganisation && 'textareaError'}`}
                name="descriptionOfOrganisation"
                placeholder={translate.formatMessage({ id: 'acc.input-description' })}
                ref={register({
                  required: true,
                })}
              />
              {errors.descriptionOfOrganisation && <div className="input__error">{translate.formatMessage({ id: 'acc.field-required' })}</div>}
            </div>
          </div>
          <div className={`registration__form-inputWrapper ${(errorWebsite) && 'registration__form-spaceForError'}`} ref={refSite}>
            <CustomInput
              type="text"
              name="website"
              change={() => setErrorWebsite(false)}
              label={translate.formatMessage({ id: 'acc.input-website' })}
              placeholder={translate.formatMessage({ id: 'acc.input-website' })}
              customClassLabel="input__label-registration bold"
              customClass="input__registration"
              error={errors.website}
              register={register({
                required: false,
              })}
            />
            {errorWebsite && <div className="input__customEmailError">{translate.formatMessage({ id: 'acc.website-error' })}</div>}
          </div>
          <div className={`registration__form-inputWrapper ${errors.shortDescription && 'registration__form-spaceForError'}`}>
            <div className="textareaBlock">
              <h4 className="textareaBlock-Label">
                {translate.formatMessage({ id: 'acc.input-shortDescription' })}
              </h4>
              <textarea
                className={`textareaBlock-Textarea ${errors.shortDescription && 'textareaError'}`}
                name="shortDescription"
                placeholder={translate.formatMessage({ id: 'acc.input-shortDescription' })}
                ref={register({
                  required: true,
                })}
              />
              {errors.shortDescription && <div className="input__error">{translate.formatMessage({ id: 'acc.field-required' })}</div>}
            </div>
          </div>
          <div className={`registration__form-inputWrapper ${errorCountries && 'registration__form-spaceForError'}`}>
            <div className="country__wrapper">
              <span className="input__label input__label-registration bold">
                {translate.formatMessage({ id: 'acc.input-country' })}
              </span>
              <CountryDropdown
                classes={`input__registration input__marginTop ${errorCountries && 'error-country'}`}
                value={countries.country}
                defaultOptionLabel={translate.formatMessage({ id: 'acc.input-countries' })}
                onChange={(val) => updateCountries(val)}
              />
              {countriesArray.length > 0 && (
              <div className="country__list">
                {countriesArray.map((el) => (
                  <div key={el} className="country__wrap-country">
                    <div className="country__country">{el}</div>
                    <i className="icon-close" onClick={() => deleteCountry(el)} />
                  </div>
                ))}
              </div>
              )}
              {errorCountries && <div className="input__error">{translate.formatMessage({ id: 'acc.country-required' })}</div>}
            </div>
          </div>
          <div className={`registration__form-inputWrapper ${errors.checkbox && 'registration__form-spaceForError'}`}>
            <div className="typesOfProjects">
              <h4 className="typesOfProjects-title">
                {translate.formatMessage({ id: 'acc.type-of-projects' })}
              </h4>
              <div className="typesOfProjects-checkboxBlock">
                {valuesCheckBox.map((el) => (
                  <label className="typesOfProjects-checkboxBlock-checkbox" key={el.id}>
                    {translate.formatMessage({ id: el.id })}
                    <input
                      className="checkboxInput"
                      type="checkbox"
                      name="checkbox"
                      defaultValue={el.value}
                      ref={register({
                        required: true,
                      })}
                    />
                    <span className="checkmark" />
                  </label>
                ))}
              </div>
              {Object.keys(errors).includes('checkbox') && <div className="input__error">{translate.formatMessage({ id: 'acc.choice-is-required' })}</div>}
            </div>
          </div>
          <div className={`registration__form-inputWrapper ${errors.howLong && 'registration__form-spaceForError'}`}>
            <CustomInput
              type="text"
              name="howLong"
              label={translate.formatMessage({ id: 'acc.input-howLong' })}
              placeholder={translate.formatMessage({ id: 'acc.input-howLongPlace' })}
              customClassLabel="input__label-registration bold small"
              customClass="input__registration"
              error={errors.howLong}
              onlyNumber
              register={register({
                min: 0,
                max: 1000000000,
                required: true,
              })}
            />
          </div>
          <CustomBtn
            label={translate.formatMessage({ id: 'acc.btn-label' })}
            customClass={classBtn}
            disabled={hasValidationErrors}
            type="submit"
            handleClick={() => {
              setCountries({ ...countries, select: true });
            }}
          />
        </form>
      </>
      {errorModal && <CustomPopup text={textError} handleClick={() => setErrorModal(!errorModal)} />}
    </section>
  );
};

export default CreateAcc;
